<app-dialog class="confirm-cancel-dialog" [hideClose]="true">
  <ng-container>
    <div class="header-close-wrapper">
      <h4 class="header-title">{{ 'module.modals.onboarding.onboardingConfirmCancelModalTitle' | translate }}</h4>
      <div class="close-button" (click)="onCancelClick()">x</div>
    </div>
  </ng-container>

  <div class="confirm-cancel-content-container">
    <ng-container>
      <div class="confirm-cancel-content">
        <div class="confirm-cancel-description">
          {{ 'module.modals.onboarding.onboardingConfirmCancelModalDescription' | translate }}
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div class="confirm-cancel-actions">
        <button class="btn btn-outline-primary" (click)="onCancelClick()">
          <span class=""></span>{{ 'module.modals.onboarding.onboardingConfirmCancelModalBackButtonLabel' | translate }}
        </button>

        <button class="btn btn-outline-secondary" (click)="onConfirmCancelClick()">
          {{ 'module.modals.onboarding.onboardingConfirmCancelModalCancelButtonLabel' | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</app-dialog>
